import React from "react";
import { Box, Tooltip } from "@material-ui/core";
import { get } from "lodash";
// import { useStyles } from "../styles";

const TargetReviewed = (colProps) => {
  // const classes = useStyles();

  return (
    <td>
      <Box>
        {get(colProps, "dataItem.leadReviewerRating") ? (
          <Tooltip title={get(colProps, "dataItem.leadReviewerRating")}>
            <span>{get(colProps, "dataItem.leadReviewerRating")}</span>
          </Tooltip>
        ) : (
          "-"
        )}
      </Box>
    </td>
  );
};

export default TargetReviewed;
